var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearchIcon = function SvgSearchIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9932 9.66667H11.28L11.0272 9.44167C11.912 8.49167 12.4446 7.25833 12.4446 5.91667C12.4446 2.925 9.81752 0.5 6.57655 0.5C3.33558 0.5 0.708496 2.925 0.708496 5.91667C0.708496 8.90833 3.33558 11.3333 6.57655 11.3333C8.03002 11.3333 9.36613 10.8417 10.3953 10.025L10.6391 10.2583V10.9167L15.1529 15.075L16.4981 13.8333L11.9932 9.66667ZM6.57655 9.66667C4.32863 9.66667 2.51405 7.99167 2.51405 5.91667C2.51405 3.84167 4.32863 2.16667 6.57655 2.16667C8.82447 2.16667 10.6391 3.84167 10.6391 5.91667C10.6391 7.99167 8.82447 9.66667 6.57655 9.66667Z",
    fill: "#338891"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search_icon.1fa026b8.svg";
export { ForwardRef as ReactComponent };